import { createSlice } from "@reduxjs/toolkit";
import {
  disableEnableTimeslot,
  fetchTimeslot,
  updateTimeslot,
} from "../actions/timeslot";
import { addAppointment, deleteAppointment } from "../actions/appointments";

const timeslotSlice = createSlice({
  name: "timeslot",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTimeslot.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTimeslot.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchTimeslot.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateTimeslot.fulfilled, (state, action) => {
        const { slotKey, deleted } = action.payload;
        if (deleted) {
          state.data = state.data.filter((item) => item.text !== slotKey);
        } else {
          state.data.push({ text: slotKey });
        }
      })
      .addCase(disableEnableTimeslot.fulfilled, (state, action) => {
        const { id, date, isDisabled } = action.payload;
        state.data = state.data.map((item) =>
          item.id === id
            ? {
                ...item,
                dates: isDisabled
                  ? [...(item.dates || []), date]
                  : item.dates.filter((d) => d !== date),
              }
            : item
        );
      })
      .addCase(addAppointment.fulfilled, (state, action) => {
        const { appointmentId, updatedTimeslotId } = action.payload;
        if (!updatedTimeslotId) return;
        state.data = state.data.map((item) => {
          if (item.text !== updatedTimeslotId) return item;
          if (Array.isArray(item.appointment)) {
            if (!item.appointment.includes(appointmentId)) {
              return {
                ...item,
                appointment: [...item.appointment, appointmentId],
              };
            }
            return item;
          } else if (
            typeof item.appointment === "string" &&
            item.appointment !== ""
          ) {
            if (item.appointment !== appointmentId) {
              return {
                ...item,
                appointment: [item.appointment, appointmentId],
              };
            } else {
              return { ...item, appointment: [item.appointment] };
            }
          } else {
            return { ...item, appointment: [appointmentId] };
          }
        });
      })
      .addCase(deleteAppointment.fulfilled, (state, action) => {
        const { timeslotId, id: appointmentId } = action.payload;
        if (timeslotId) {
          state.data = state.data.map((item) => {
            if (item.text !== timeslotId) return item;
            if (Array.isArray(item.appointment)) {
              return {
                ...item,
                appointment: item.appointment.filter(
                  (aId) => aId !== appointmentId
                ),
              };
            } else if (
              typeof item.appointment === "string" &&
              item.appointment !== ""
            ) {
              if (item.appointment === appointmentId) {
                return { ...item, appointment: [] };
              } else {
                return item;
              }
            } else {
              return item;
            }
          });
        }
      });
  },
});

export default timeslotSlice.reducer;
